
<template lang="pug">
.shifts-item(
  :style="style"
  tabIndex=0
  @contextmenu.prevent.stop="$emit('contextmenu', $event, item)"
  @mousedown.left.stop="onMouseDown($event, item)"
  @mousemove="onMouseMove($event, item)"
  @mouseleave="onMouseLeave"
)
  .shifts-item__frame(:class="frameClass")
    .shifts-item__label(:style="labelStyle") {{item.label}}
    span.invisible(ref="labelRuler") {{item.label}}
    div(ref="frameRuler")
</template>

<script>
const edgeW = 12

export default {
  props: {
    grid: Object,
    item: Object,
  },

  data() {
    return {
      labelStyle: null,
    }
  },

  computed: {
    style() {
      return {
        left:    this.item.begin                  * this.grid.cellW + 'px',
        top:     this.item.row                    * this.grid.cellH + 'px',
        width:  (this.item.end - this.item.begin) * this.grid.cellW + 'px',
        zIndex:  this.item.state === 'focus' ? 1 : null,
      }
    },

    frameClass() {
      const frameClass = []
      for(const key of ['color', 'state']) {
        const value = this.item[key]
        if(value) {
          frameClass.push('shifts-item__frame--' + value)
        }
      }
      return frameClass
    },
  },

  watch: {
    item: {
      deep: true,
      handler() {
        this.$nextTick(this.shrinkLabel)
      },
    },
  },

  mounted() {
    this.shrinkLabel()
  },

  methods: {

    shrinkLabel() {
      const labelWidth = this.$refs.labelRuler.offsetWidth
      if(0 < labelWidth) {
        const scale = this.$refs.frameRuler.offsetWidth / labelWidth
        if(scale < 1) {
          this.labelStyle = {
            transform: 'scaleX(' + scale + ')',
            'transform-origin': 'left',
          }
          return
        }
      }
      this.labelStyle = null
    },

    onMouseDown(e, item) {
      this.$emit(
          e.offsetX                                                       < edgeW ? 'mousedownleftedge'
        : (this.item.end - this.item.begin) * this.grid.cellW - e.offsetX < edgeW ? 'mousedownrightedge'
        :                                                                           'mousedown',
      e, item)
    },

    onMouseMove(e) {
      document.body.style.cursor =
          e.offsetX                                                       < edgeW ? 'w-resize'
        : (this.item.end - this.item.begin) * this.grid.cellW - e.offsetX < edgeW ? 'e-resize'
        :                                                                           'move'
    },

    onMouseLeave() {
      document.body.style.cursor = 'default'
    },
  },
}
</script>

<style lang="sass">

@import 'mixins/AppTheme.sass'

$colorItem:            rgba(192, 216, 255, .8)
$colorItemNonRegister: rgba(192, 255, 192, .8)
$colorItemHidden:      rgba(255, 192, 192, .8)
$colorItemWarning:     rgba(255, 160,   0, .8)
$colorItemError:       rgba(255,   0,   0, .8)

.shifts-item
  height: 25px
  position: absolute
  user-select: none

.shifts-item:focus
  outline: none

.shifts-item__frame
  background-color: $colorItem
  border: solid 1px $colorBorder
  border-radius: 3px
  bottom: 3px
  left: 2px
  padding: 0 2px
  pointer-events: none
  position: absolute
  right: 3px
  top: 2px
  transition: transform .3s ease
  white-space: nowrap

.shifts-item__frame--focus
  transform: translateY(-1px)

.shifts-item__frame--non-register
  background-color: $colorItemNonRegister

.shifts-item__frame--hidden
  background-color: $colorItemHidden

.shifts-item__frame--warning
  background-color: $colorItemWarning

.shifts-item__frame--error
  background-color: $colorItemError

.shifts-item__frame::after
  border-radius: 3px
  box-shadow: 4px 7px 8px rgba(0, 0, 0, .4)
  content: ''
  height: 100%
  left: 0
  opacity: 0
  position: absolute
  top: 0
  transition: opacity .3s ease
  width: 100%

.shifts-item__frame--focus::after
  opacity: 1

.shifts-item__label
  align-items: center
  display: flex
  height: 100%

</style>
